<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Producer' }">板商列表</el-breadcrumb-item>
          <el-breadcrumb-item>编辑板商</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          基本信息
        </el-row>
          <el-divider></el-divider>
        <el-form
          :model="producer"
          :rules="rules"
          ref="customerForm"
          label-width="130px"
          label-position="right"
          style="padding-top:0px !important"
          size="mini"
        >
        <el-row>
          <el-col :span="6">
             <el-form-item label="标识号/主账号用户名" prop="code">
            <el-input disabled v-model="producer.code" maxlength="20"></el-input>
          </el-form-item>
          </el-col>

          <el-col :span="6">
           <el-form-item label="板商名称" prop="name">
            <el-input v-model="producer.name" maxlength="20"></el-input>
          </el-form-item>
          </el-col>
              <el-col :span="6">
            <el-form-item label="所在城市" prop="city">
            <el-input v-model="producer.city" maxlength="7" placeholder="仅填写城市名称，如“杭州”"></el-input>
          </el-form-item>
              </el-col>
               <el-col :span="6">
            <el-form-item label="领科ID" prop="linksid">
            <el-input v-model="producer.linksid" maxlength="45" placeholder="领科系统编号"></el-input>
          </el-form-item>
              </el-col>
               <el-col :span="6">
            <el-form-item label="LOGO图片" prop="logo">
           <el-upload
            style="text-align:left"
              class="avatar-uploader"
              name="upload"
              action="https://resource.mibee.cn/resource/upload?isauth=0&type=2&program_type=BASE&filename="
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img  v-if="producer.logo" :src="'https://resource.mibee.cn/resource/' + producer.logo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-button  v-if="producer.logo" type="text" @click="producer.logo=''">删除LOGO</el-button>
          </el-form-item>
              </el-col>
              <el-col :span="6">
            <el-form-item>
            <el-button type="primary" size="small" @click="saveDealer()">保存</el-button>
          </el-form-item>
              </el-col>
             </el-row>

        </el-form>

    <el-tabs v-model="activeName" style="width:calc(100% - 60px);margin-left:30px;" >
    <el-tab-pane label="帐号列表" name="first">
      <div style="height: 100%; background: #F2F2F6">
       <!-- <el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="8">
       <el-form-item label="用户名">
    <el-input v-model="where.username"></el-input>
  </el-form-item>
    </el-col>
       <el-col :span="8"> <el-form-item label=""></el-form-item></el-col>
       <el-col :span="8" style="text-align:right">
        <el-button size="small" type="primary" @click="searchAccount()">查询</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button title="新增" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="createRole()"></el-button>
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form> -->
        <el-table
          :data="accountdata"
          ref="table"
          stripe
          border
          style="width:100%;border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            :index="indexMethod"
          ></el-table-column>
           <el-table-column prop="username" label="用户名">
            </el-table-column>
            <el-table-column prop="mobile" label="管理员">
              <template  slot-scope="scope"  >
                <span v-if="scope.row.isadmin">管理员</span>
              </template>
            </el-table-column>
          <el-table-column label="操作" column-key="opt" width="250">
            <template  slot-scope="scope"   v-if="false">
               <el-button
                size="mini"
                type="text"
                @click="updateAccount(scope.row)"
                >修改</el-button
              >
               <el-divider direction="vertical"></el-divider>
              <el-button
              size="mini"
                type="text"
                @click="deleteAccount(scope.row)"
                >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>

    </el-tab-pane>
    <el-tab-pane label="相关协议" name="second">
         <div style="height: 100%; background: #F2F2F6">
          <el-row>
            <el-button type="primary" @click="newProtocol()">添加新协议</el-button>
            <el-button type="primary" @click="newCustProtocol()">自定义协议生成</el-button>
            <el-button type="primary" @click="newSetProtocol()">组合协议生成</el-button>
          </el-row>
          <el-divider></el-divider>
        <el-table
          :data="protocoldata"
          ref="table"
          stripe
          border
          style="width:100%;border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            width="75"
            :index="protocolindexMethod"
          ></el-table-column>
           <el-table-column prop="desc" label="名称">
            </el-table-column>
            <el-table-column prop="protocolid" label="Prorotolid" >
            </el-table-column>
            <el-table-column prop="cfgver" label="版本号" >
            </el-table-column>
            <el-table-column prop="hide" label="隐藏">
            <template slot-scope="scope">
              <el-switch  size="mini"  v-model="scope.row.hide"
    active-color="#13ce66"
    inactive-color="#ff4949"
    :active-value="1"
    :inactive-value="0"
    @change="updateHide(scope.row)"
    >
  </el-switch>
            </template>
           </el-table-column>

          <el-table-column label="操作" column-key="opt">
            <template  slot-scope="scope"  >
              <el-button  style="font-size:12px" type="text" @click="editProtocol(scope.row)">编辑</el-button>
              <el-button  v-if="scope.row.protocolid>=3000&&!scope.row.set" style="font-size:12px" type="text" @click="editCustProtocol(scope.row)">模版编辑</el-button>
              <el-button  v-if="scope.row.set" style="font-size:12px" type="text" @click="editSetProtocol(scope.row)">组合协议</el-button>
              <el-button  v-if="!scope.row.set" style="font-size:12px" type="text" @click="showDp(scope.row)">DP查看</el-button>
              <el-button  v-if="!scope.row.set" style="font-size:12px" type="text" @click="showError(scope.row)">故障码查看</el-button>
              <el-button
              size="mini"
                type="text"
                @click="deleteProtocol(scope.row)"
                >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="protocolpageset.index"
          :page-size="protocolpageset.size"
          @size-change="handleProtocolSizeChange"
          @current-change="handleProtocolCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="protocoltotalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>
    </el-tab-pane>
         <el-tab-pane label="版本控制" name="third">
         <div style="height: 100%; background: #F2F2F6">
          <el-row>
            <el-button type="primary" @click="newVersion()">新增版本控制</el-button>
          </el-row>
          <el-divider></el-divider>
        <el-table
          :data="versiondata"
          ref="table"
          stripe
          border
          style="width:100%;border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
          ></el-table-column>
           <el-table-column prop="format" label="硬件版本">
             <template  slot-scope="scope"  >
             <el-select
    style="width:100%"
          v-model="scope.row.format"
          filterable
          size="mini">
             <el-option v-for="p in versions" :label="p.name+'('+(p.format||'-')+')'" :value="p.format" :key="p.innerid"></el-option>
          </el-select>
             </template>
            </el-table-column>
            <el-table-column prop="lowerversion" label="最低版本">
              <template  slot-scope="scope"  >
              <el-input size="mini" v-model="scope.row.lowerversion" autocomplete="off"></el-input>
              </template>
            </el-table-column>
          <el-table-column label="操作" column-key="opt">
            <template  slot-scope="scope"  >
             <el-button
              size="mini"
                type="text"
                @click="saveVersion(scope.row)"
                >保存</el-button>
              <el-button
              size="mini"
                type="text"
                @click="delVersion(scope.row)"
                >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
  </div>
    </el-tab-pane>
  </el-tabs>
  <el-dialog title="协议编辑" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
  <el-form :model="protocol"
  ref="ProtocolForm"
  size="mini"
          :rules="protocolrules">
    <el-form-item label="Protocolid" prop="protocolid" label-width="140px">
      <el-input size="mini" :disabled="protocol.innerid" type="number" v-model="protocol.protocolid" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="cfgver" prop="cfgver"  label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.cfgver" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="mibee.json" prop="mibeejson" label-width="140px">
      <el-input  type="textarea" resize="none" :rows="3" size="mini"  v-model="protocol.mibeejson" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="modbus.json" prop="modbusjson" label-width="140px">
      <el-input  type="textarea" resize="none"  :rows="3" size="mini" v-model="protocol.modbusjson" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="uart1" prop="uart1" label-width="140px">
      <el-input size="mini"  v-model="protocol.uart1" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="uart2" prop="uart2" label-width="140px">
      <el-input size="mini" v-model="protocol.uart2" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="最低固件版本" prop="lowversion" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.lowversion" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="最高固件版本" prop="highversion" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.highversion" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="欧版最低固件版本" prop="lowversion_eu" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.lowversion_eu" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="欧版最高固件版本" prop="highversion_eu" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.highversion_eu" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="全球通最低固件版本" prop="lowversion_global" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.lowversion_global" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="全球通最高固件版本" prop="highversion_global" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.highversion_global" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="线控器最低固件版本" prop="lowversion_xk" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.lowversion_xk" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="线控器最高固件版本" prop="highversion_xk" label-width="140px">
      <el-input size="mini" type="number" v-model="protocol.highversion_xk" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="备注" prop="remark" label-width="140px">
      <el-input size="mini" v-model="protocol.remark" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveProtocol()">确 定</el-button>
  </div>
</el-dialog>
<el-dialog title="DP列表" :visible.sync="dpFormVisible" width="75%">
  <el-table
          :data="dpdata"
          ref="table"
          height="400"
          stripe
          border
          style="width:100%;border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="dpIndexMethod"
            width="75"
          ></el-table-column>
           <el-table-column prop="dpid" label="dpid">
            </el-table-column>
            <el-table-column prop="name" label="tag" width="100">
            </el-table-column>
            <el-table-column prop="desc" label="描述">
            </el-table-column>
            <el-table-column prop="type" label="type" width="50">
            </el-table-column>
            <el-table-column prop="xrw" label="xrw" width="50">
            </el-table-column>
            <el-table-column prop="min" label="min">
            </el-table-column>
            <el-table-column prop="max" label="max">
            </el-table-column>
            <el-table-column prop="step" label="步长" width="75">
            </el-table-column>
            <el-table-column prop="unit" label="单位" width="75">
            </el-table-column>
            <el-table-column prop="values" label="枚举值">
            </el-table-column>
            <el-table-column prop="text" label="枚举文本">
            </el-table-column>

        </el-table>

    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="dppageset.index"
          :page-size="dppageset.size"
          @size-change="handleDpSizeChange"
          @current-change="handleDpCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="dptotalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dpFormVisible = false">关闭</el-button>
  </div>
</el-dialog>
<el-dialog title="故障代码列表" :visible.sync="errorFormVisible" width="75%">
  <el-table
          :data="errordata"
          ref="table"
          stripe
          border
          style="width:100%;border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="75"
            :index="errorIndexMethod"
          ></el-table-column>
          <el-table-column prop="code" label="code">
            </el-table-column>
           <el-table-column prop="desc" label="故障">
            </el-table-column>
            <el-table-column prop="errcode" label="errcode">
            </el-table-column>
            <el-table-column prop="desc_en" label="翻译">
            </el-table-column>
            <el-table-column prop="errpush" label="推送等级" width="100">
            </el-table-column>
        </el-table>

    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="errorpageset.index"
          :page-size="errorpageset.size"
          @size-change="handleErrorSizeChange"
          @current-change="handleErrorCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="errortotalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  <div slot="footer" class="dialog-footer">
    <el-button @click="errorFormVisible = false">关闭</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CreateUser',
  data () {
    return {
      activeName: 'first',
      protocolid: 0,
      producer: {
        name: '',
        code: '',
        city: '',
        logo: '',
        linksid: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      protocolrules: {
        protocolid: [{ required: true, message: '请输入Protocolid', trigger: 'blur' }],
        cfgver: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        mibeejson: [{ required: true, message: '请输入Mibee.json', trigger: 'blur' }],
        modbusjson: [{ required: true, message: '请输入Modbus.json', trigger: 'blur' }],
        uart1: [{ required: true, message: '请输入uart1', trigger: 'blur' }],
        uart2: [{ required: true, message: '请输入uart2', trigger: 'blur' }],
        lowversion: [{ required: true, message: '最低固件版本', trigger: 'blur' }],
        highversion: [{ required: true, message: '最高固件版本', trigger: 'blur' }],
        lowversion_eu: [{ required: true, message: '欧版最低固件版本', trigger: 'blur' }],
        highversion_eu: [{ required: true, message: '欧版最高固件版本', trigger: 'blur' }],
        lowversion_global: [{ required: true, message: '全球通最低固件版本', trigger: 'blur' }],
        highversion_global: [{ required: true, message: '全球通最高固件版本', trigger: 'blur' }],
        lowversion_xk: [{ required: true, message: '线控器最低固件版本', trigger: 'blur' }],
        highversion_xk: [{ required: true, message: '线控器最高固件版本', trigger: 'blur' }]
      },
      accountdata: [],
      protocoldata: [],
      versions: [],
      dpdata: [],
      errordata: [],
      versiondata: [],
      protocolpageset: {
        size: 15,
        index: 1
      },
      dppageset: {
        size: 10,
        index: 1
      },
      errorpageset: {
        size: 10,
        index: 1
      },
      protocoltotalsize: 0,
      dptotalsize: 0,
      errortotalsize: 0,
      where: {
        code: ''
      },
      dialogFormVisible: false,
      dpFormVisible: false,
      errorFormVisible: false,
      protocol: {
        cfgver: 1,
        producerid: this.$route.params.innerid,
        lowversion: 0,
        highversion: 0,
        lowversion_eu: 0,
        highversion_eu: 0,
        lowversion_global: 0,
        highversion_global: 0,
        lowversion_xk: 0,
        highversion_xk: 0,
        remark: null
      },
      pageset: {
        size: 15,
        index: 1
      },
      totalsize: 0,
      user: {}
    }
  },
  mounted: function () {
    let user = window.localStorage.getItem('customer')
    if (user) {
      this.user = JSON.parse(user)
      let self = this
      this.searchAccount()
      this.searchProtocol()
      this.searchVersionl()
      Vue.axios
        .post('/producer/query', {
          innerid: this.$route.params.innerid
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.producer = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/version/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.versions = res.data.msgbody
          } else {
          }
        })
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    handleAvatarSuccess (response) {
      this.producer.logo = response.uuid
      this.$forceUpdate()
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    saveDealer () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          Vue.axios
            .post('/producer/edit',
              self.producer
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '板商保存成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    protocolindexMethod (index) {
      return (this.protocolpageset.index - 1) * this.protocolpageset.size + index + 1
    },
    dpIndexMethod (index) {
      return (this.dppageset.index - 1) * this.dppageset.size + index + 1
    },
    errorIndexMethod (index) {
      return (this.errorpageset.index - 1) * this.errorpageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchAccount()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchAccount()
    },
    handleProtocolSizeChange (val) {
      this.protocolpageset.size = val
      this.searchProtocol()
    },
    handleProtocolCurrentChange (val) {
      this.protocolpageset.index = val
      this.searchProtocol()
    },
    handleDpSizeChange (val) {
      this.dppageset.size = val
      this.searchDp()
    },
    handleDpCurrentChange (val) {
      this.dppageset.index = val
      this.searchDp()
    },
    handleErrorSizeChange (val) {
      this.errorpageset.size = val
      this.searchError()
    },
    handleErrorCurrentChange (val) {
      this.errorpageset.index = val
      this.searchError()
    },
    searchAccount () {
      let self = this
      Vue.axios
        .post('/producer/account/list', {
          producerid: this.$route.params.innerid,
          where: self.where,
          pageset: self.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.accountdata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/producer/account/count', {
          producerid: this.$route.params.innerid,
          where: self.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    searchProtocol () {
      Vue.axios
        .post('/producer/protocol/list', {
          producerid: this.$route.params.innerid,
          pageset: this.protocolpageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.protocoldata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/producer/protocol/count', {
          producerid: this.$route.params.innerid
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.protocoltotalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    searchDp () {
      Vue.axios
        .post('/protocol/dp/list', {
          protocolid: this.protocolid,
          pageset: this.dppageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.dpdata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/protocol/dp/count', {
          protocolid: this.protocolid
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.dptotalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    searchError () {
      Vue.axios
        .post('/protocol/errorcode/list', {
          protocolid: this.protocolid,
          pageset: this.errorpageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.errordata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/protocol/errorcode/count', {
          protocolid: this.protocolid
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.errortotalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    back () {
      this.$router.back()
    },
    newCustProtocol () {
      this.$router.push({name: 'CreateProtocol', params: {type: 2, related: this.producer.innerid, innerid: ''}})
    },
    newSetProtocol () {
      this.$router.push({name: 'CreateSetProtocol', params: {type: 2, related: this.producer.innerid, innerid: ''}})
    },
    newProtocol () {
      this.protocol = {
        cfgver: 1,
        producerid: this.$route.params.innerid,
        lowversion: 0,
        highversion: 0,
        lowversion_eu: 0,
        highversion_eu: 0,
        lowversion_global: 0,
        highversion_global: 0,
        lowversion_xk: 0,
        highversion_xk: 0,
        remark: null
      }
      this.dialogFormVisible = true
    },
    editProtocol (row) {
      this.protocol = row
      this.dialogFormVisible = true
    },
    editCustProtocol (row) {
      this.$router.push({name: 'CreateProtocol', params: {type: 2, related: this.producer.innerid, innerid: row.innerid}})
    },
    editSetProtocol (row) {
      this.$router.push({name: 'CreateSetProtocol', params: {type: 2, related: this.producer.innerid, innerid: row.innerid}})
    },
    deleteProtocol (row) {
      let self = this
      this.$confirm(
        '确定删除协议' + row.desc + '？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          let url = '/producer/protocol/del'
          if (row.protocolid >= 3000) {
            url = '/producer/protocol/cust/del'
          }
          Vue.axios
            .post(url, {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                self.searchProtocol()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    },
    saveProtocol () {
      this.$refs.ProtocolForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          Vue.axios
            .post('/producer/protocol/edit',
              self.protocol
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '协议保存成功',
                  type: 'success'
                })
                self.dialogFormVisible = false
                self.searchProtocol()
              } else {
                this.$message({
                  showClose: true,
                  message: '保存失败，请检查是否protocid重复',
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    showDp (row) {
      this.protocolid = row.protocolid
      this.dppageset.index = 1
      this.searchDp()
      this.dpFormVisible = true
    },
    showError (row) {
      this.protocolid = row.protocolid
      this.errorpageset.index = 1
      this.searchError()
      this.errorFormVisible = true
    },
    searchVersionl () {
      Vue.axios
        .post('/producer/mibee/version/all', {
          producerid: this.$route.params.innerid
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.versiondata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    newVersion () {
      this.versiondata.unshift({
        innerid: this.Common.newGuid(),
        producerid: this.$route.params.innerid,
        format: '',
        lowerversion: 0,
        newrecord: true
      })
    },
    delVersion (row) {
      let self = this
      if (row.newrecord) {
        this.versiondata = this.versiondata.filter(a => { return a.innerid != row.innerid })
        return
      }
      this.$confirm(
        '确定删除该版本控制？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/producer/mibee/version/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                self.versiondata = self.versiondata.filter(a => { return a.innerid != row.innerid })
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    },
    saveVersion (row) {
      let self = this
      if (!row.format || !row.lowerversion) {
        this.$message({
          showClose: true,
          message: '请填入硬件版本及最低版本号',
          type: 'error'
        })
        return
      }
      this.versiondata.filter(a => { return !a.newrecord }).forEach(v => {
        if (v.format == row.format && v.innerid != row.innerid) {
          this.$message({
            showClose: true,
            message: '硬件版本已存在，请修改',
            type: 'error'
          })
          throw '硬件版本已存在，请修改'
        }
      })
      Vue.axios
        .post('/producer/mibee/version/save',
          row
        )
        .then((res) => {
          if (res.data.errcode == 0) {
            self.$message({
              message: '保存成功',
              type: 'success'
            })
            if (row.newrecord) {
              delete row.newrecord
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    updateHide (row) {
      Vue.axios
        .post('/producer/protocol/hide/edit', {hide:row.hide,innerid:row.innerid})
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$message({
              type: 'success',
              message: this.$t('base.saveSuccess')
            })
            this.searchProtocol()
          } else {
            this.$message({
              showClose: true,
              message:
                    res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-collapse-item__wrap,
.el-collapse-item__header
{
background: #F2F2F6;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .el-upload-list--picture-card .el-upload-list__item {
     width: 100px;
  height: 100px;
    line-height: 100px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
   width: 100px;
  height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
   width: 100px;
  height: 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Producer/Edit.vue